const globalDataReducer = function reducer(
	state = {
		bannerDismissed: false,
	},
	action
) {
	switch (action.type) {
		case 'SET_BANNER_DISMISSED': {
			return { ...state, bannerDismissed: action.dismissed }
		}
	}
	return state
}
export default globalDataReducer
